// type
const PAGE_NUMBER = "PAGE_NUMBER";

// action
export const setPageNumber = (pageNumber) => ({
  type: PAGE_NUMBER,
  payload: pageNumber
});

// reducer
export const pageNumberReducer = (state = 1, action) => {
  switch (action.type) {
    case PAGE_NUMBER:
      state = action.payload;
      return state;
    default:
      return state;
  }
};
